import React from 'react';
import { SVGProps } from '@/components/icon/Icon.types';

export const EmptyAudiences = ({ className }: SVGProps) => {
  return (
    <svg
      className={className}
      width="200"
      height="200"
      viewBox="0 0 200 200"
      aria-hidden="true"
      focusable="false"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.2"
        d="M188.982 97.3708C190.052 142.644 143.812 182.669 100.629 181.992C55.705 181.287 5.07054 144.598 11.566 87.5087C17.2815 37.2748 46.8858 19.5053 96.7521 18.0436C146.618 16.5818 187.911 52.0978 188.982 97.3708Z"
        fill="#8FAAC7"
      />
      <path
        d="M79.2049 134.528C79.6684 129.184 82.1243 124.209 86.0852 120.592C90.046 116.975 95.2222 114.979 100.586 115C105.95 115.022 111.11 117.06 115.042 120.709C118.973 124.358 121.389 129.352 121.809 134.7L100.5 136.375L79.2049 134.528Z"
        fill="#12B4D9"
      />
      <circle cx="100.875" cy="94.75" r="16.5" fill="white" />
      <path
        d="M38.875 103.25C38.875 101.674 39.1951 100.114 39.817 98.6578C40.4389 97.2019 41.3504 95.879 42.4996 94.7647C43.6487 93.6504 45.0129 92.7665 46.5143 92.1634C48.0157 91.5604 49.6249 91.25 51.25 91.25C52.8751 91.25 54.4843 91.5604 55.9857 92.1634C57.4871 92.7665 58.8513 93.6504 60.0005 94.7647C61.1496 95.879 62.0611 97.2019 62.683 98.6578C63.3049 100.114 63.625 101.674 63.625 103.25L51.25 103.25L38.875 103.25Z"
        fill="#FFAF6B"
      />
      <circle cx="51.625" cy="77" r="10.5" fill="white" />
      <path
        d="M136.375 127.25C136.375 125.674 136.695 124.114 137.317 122.658C137.939 121.202 138.85 119.879 140 118.765C141.149 117.65 142.513 116.767 144.014 116.163C145.516 115.56 147.125 115.25 148.75 115.25C150.375 115.25 151.984 115.56 153.486 116.163C154.987 116.767 156.351 117.65 157.5 118.765C158.65 119.879 159.561 121.202 160.183 122.658C160.805 124.114 161.125 125.674 161.125 127.25L148.75 127.25L136.375 127.25Z"
        fill="#A687FE"
      />
      <circle cx="149.125" cy="101" r="10.5" fill="white" />
      <rect x="98" y="54" width="4" height="16" fill="#333333" />
      <rect x="98" y="130" width="4" height="16" fill="#333333" />
      <rect
        x="54"
        y="102"
        width="4"
        height="16"
        transform="rotate(-90 54 102)"
        fill="#333333"
      />
      <rect
        x="130"
        y="102"
        width="4"
        height="16"
        transform="rotate(-90 130 102)"
        fill="#333333"
      />
      <circle cx="100" cy="100" r="38" stroke="#333333" strokeWidth="4" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M151 51.2C151 50.6477 151.448 50.2 152 50.2H162C162.552 50.2 163 50.6477 163 51.2C163 51.7522 162.552 52.2 162 52.2H152C151.448 52.2 151 51.7522 151 51.2Z"
        fill="#D80C86"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M156.8 45C157.352 45 157.8 45.4477 157.8 46L157.8 56C157.8 56.5523 157.352 57 156.8 57C156.248 57 155.8 56.5523 155.8 56L155.8 46C155.8 45.4477 156.248 45 156.8 45Z"
        fill="#D80C86"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M125 47C125 46.4477 125.448 46 126 46H132C132.552 46 133 46.4477 133 47C133 47.5523 132.552 48 132 48H126C125.448 48 125 47.5523 125 47Z"
        fill="#12B4D9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M129 43C129.552 43 130 43.4477 130 44L130 50C130 50.5523 129.552 51 129 51C128.448 51 128 50.5523 128 50L128 44C128 43.4477 128.448 43 129 43Z"
        fill="#12B4D9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M135 26C135 25.4477 135.448 25 136 25H144C144.552 25 145 25.4477 145 26C145 26.5523 144.552 27 144 27H136C135.448 27 135 26.5523 135 26Z"
        fill="#0FCE72"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M140 21C140.552 21 141 21.4477 141 22L141 30C141 30.5523 140.552 31 140 31C139.448 31 139 30.5523 139 30L139 22C139 21.4477 139.448 21 140 21Z"
        fill="#0FCE72"
      />
    </svg>
  );
};
